import { AccordionInterceptor } from '@vfde-fe/ngx-lib/components/accordion';
import { Component, OnInit, VERSION } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { defaultPageScrollConfig } from 'ngx-page-scroll-core';
import { Location } from '@angular/common';
import { SpinnerService } from '@vfde-fe/ngx-lib/components/spinner';
import { TrackingInterceptor } from '@vfde-fe/ngx-lib/plugins/tracking';
import { SpinnerStatus } from '@vfde-fe/ngx-lib/components/spinner';
import { SetUserCredentials, SetCID } from './redux/actions/order-details-extend.actions';
import { UserCredentials } from './models/userCredential.model';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import { Store } from '@ngrx/store';
import { AppState } from './redux/reducers';
/** AppComponent */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
/** generalLoader */
    public generalLoader: boolean;

    public constructor (
        translate: TranslateService,
        spinnerService: SpinnerService,
        private trackingInterceptor: TrackingInterceptor,
        private accordionInterceptor: AccordionInterceptor,
        private location: Location,
        private routeUtil: RoutesUtilsService,
        private store: Store<AppState>,

    ) {

        const base = document.getElementsByTagName('base')[0];

        base.setAttribute('href', '/simplicity/after-sales/js/');

        console.log('%c🎉🎉  ' + VERSION.full + '  🎉🎉',  'font-size: 50px;');

        // if application is loaded with a H&S accordion opened. this removes the hash to close the accordion
        if (location.path(true).indexOf('#') !== -1) {
            location.go(location.path(true).split('#')[0]);
        }
        // this language will be used as a fallback when a translation isn't found in the current language
        translate.setDefaultLang('defaultWording');
        // the lang to use, if the lang isn't available, it will use the current loader to get them
        translate.use('deWording');

        // execute general loader callback with this to use generalLoader property
        spinnerService.generalLoaderCallback(this.switchGeneralLoaderSpinner, this);

        /** page scrolling configuration */

        defaultPageScrollConfig.scrollOffset = 10;

        // Start accordion interceptor
        accordionInterceptor.init();

        // Start tracking Interceptor
        trackingInterceptor.init();
    }

    /** ngOnInit  set user credentials in case of deep link */
    public ngOnInit () {
        this.setUserCredentials();
    }

    /**
     * switch the boolean indicator to load the spinner or show the router outlet.
     */
    private switchGeneralLoaderSpinner (that: any, spinnerStatus: SpinnerStatus) {
        that.generalLoader = (spinnerStatus === SpinnerStatus.START) ? true : false;
    }

    /**
     * set user credentials in case of deep link
     */
    public setUserCredentials () {
        const params = this.routeUtil.getParamsFromUrl();
        const keys = params && Object.keys(params);
        const onlyC_id = keys && keys.length === 1 && keys[0] == 'c_id';
        params && params['c_id'] && this.store.dispatch(new SetCID({c_id:  params['c_id']}));
        if (params && !onlyC_id) {
            const userCredentials = {
                deliveryNumber: params['request-id'],
                zipCode: params['post-code'],
                orderNumber: params['order-id'],
                type: params['type'],
            } as UserCredentials;
            this.store.dispatch(new SetUserCredentials({ userCredentials: userCredentials }));
        }
    }
}
